import React from "react";
import ReactExport from "react-export-excel";
import {CustomInput,TextQuestion,Button,LoadingSpinner,QuestionTypeSelector,MultipleChoiceQuestion,CheckBoxChoiceQuestion} from "../../components"

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//value={(col) => col.is_married ? "Married" : "Single"}
class ExportButton extends React.Component {
    render() {
        const {data,surveyName,candidate} = this.props;
        console.log(surveyName)
        return (
            <ExcelFile filename={"Ispani "+surveyName+" "+candidate} element={<Button style={{marginBottom:18,padding:10}} color="primary">Export</Button>}>
                <ExcelSheet data={data} name="candidate">
                    <ExcelColumn label="Agent Name" value="name"/>
                    <ExcelColumn label="Agent Surname" value="surname"/>
                    <ExcelColumn label="Agent Phone Number" value="phoneNumber"/>
                    <ExcelColumn label="Agent Balance" value="balance"/>
                    <ExcelColumn label="Agent Address" value="address"/>
                    <ExcelColumn label="Candidate phone number" value="candidate"/>
                    <ExcelColumn label="Question No." value="index"/>
                    <ExcelColumn label="Questions" value="question"/>
                    <ExcelColumn label="Answers" value="answer"/>
                </ExcelSheet>
            </ExcelFile>
        );
    }
}

export default (ExportButton);


// WEBPACK FOOTER //
// ./src/components/CustomButtons/ExportButton.jsx